module.exports = __webpack_public_path__ + "img/banpara.08e8bab7.svg";